const config = {
    direction: {
        HORIZONTAL: 'Horizontal',
        VERTICAL: 'Vertical',
        WRAP: 'Wrap',
        FLUID: 'Fluid',
    },

    spacing: {
        COMFY: 'Comfy', // Most padding
        COZY: 'Cozy', // Medium padding
        COMPACT: 'Compact', // Least padding
        NONE: 'None', // No padding
    },
};

export default config;
